import React, { forwardRef, useImperativeHandle,useRef,useEffect } from "react";
// import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { useClientTypes } from "../../context/ClientTypeContext"; 

import { useMasterData } from "../../context/MasterDataContext";



const Comp_ProjectDeveloper = forwardRef(({
    maxTags = undefined,
    // style = '',

    style={},   // container style
    tagStyle={},  // tags
    inputStyle={}, // input field


    defaultTags = [],
    selectedTags = [],
    setSelectedTags = () => {},

    onDeveloperSelect,
    onDeveloperRemove,
    onDeveloperChangeTag,
    onDeveloperNotFound,


    // onCitySelect,
    // onCityRemove,
    // onCityChangeTag,
    // onCityNotFound,


}, ref) => {
    const placeHolder = "Select Project Developer";

    const {developers:masterDevelopers,developersReady:developersReady}= useMasterData();
    

    const tagrefDeveloper = useRef(null);
    const hasInitialized = useRef(false);


/**
     * Resolve Client Type IDs or mixed tags into full colony objects from masterClienttype.
     * @param {Array<number|string|object>} idsOrObjects
     * @param {string} defaultStatus
     * @returns {Array<object>}
     */
    function getObjectFromIds(idsOrObjects ,defaultStatus = "default") {
      if (!Array.isArray(idsOrObjects) || !Array.isArray(masterDevelopers)) return [];
      return idsOrObjects
        .map(tagOrId => {
          if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'name' in tagOrId) {
            return tagOrId;
          }
          const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
            ? parseInt(tagOrId, 10)
            : tagOrId;
          return masterDevelopers.find(col => {
            const cid = col.id;
            return (
              (typeof cid === 'number' && cid === rawId) ||
              (typeof cid === 'string' && cid === ('' + rawId))
            );
          });
        })
        .filter(Boolean)
        .map(ctype => ({
          ...ctype,
          status: defaultStatus
        }));
      }



// useEffect(() => {
//   if (
//     developersReady // ensure masterColonies are loaded
//   ) {

//     const initialTags = getObjectFromIds(selectedTags)

//     tagrefDeveloper.current.setTags(initialTags);
//     hasInitialized.current = true;
//   }
// }, [developersReady,masterDevelopers]);


useEffect(() => {
  if (
    developersReady &&
    tagrefDeveloper.current &&
    !hasInitialized.current
  ) {
    const initialTags = getObjectFromIds(selectedTags);
    tagrefDeveloper.current.setTags(initialTags);

    hasInitialized.current = true;
  }
}, [developersReady, masterDevelopers]);


    const handleSelectTag = (tag) => {
        if (onDeveloperSelect) {
            onDeveloperSelect(tag);
        }
    };

    const handleRemoveTag = (tag) => {
        if (onDeveloperRemove) {
            onDeveloperRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        if (onDeveloperChangeTag) {
            onDeveloperChangeTag(AllTags);
        }
    };

    const handleDeveloperNotFound = (payload) => {
      // payload contains: value, displayKey, parentKey, etc.
      console.log("Developer not found",payload)
      if (onDeveloperNotFound) {
        onDeveloperNotFound({
          ...payload,
          source: "developers",
        });
      }
    };



    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getClientTypeTags: () => tagrefCities.current.getTags(),
        // setClientTypeTags: (selected) => tagrefCities.current.setTags(selected),
        getObjectFromIds,
        getDeveloperTags: () => selectedTags,
        setDeveloperTags: (tags) => setSelectedTags(tags),            
        getTagsbyIds: (ids) => getTags(ids)
    }));





    function getTags(ids) {
        if (ids.length > 0) {
            return masterDevelopers.filter(record => ids.includes(record.id));
        } else {
            return [];
        }
    }

    return (
        <div>
            <ComponentTagSelector
                ref={tagrefDeveloper}
                // style={style}

                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field

                suggestions={masterDevelopers} // Ensure this is populated
                defaultTags={defaultTags} // Use internal state for defaultTags
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}
                maxTags={maxTags}
                displayKey="name" // Ensure this matches the key in masterDevelopers
                // allowFreeAdd={true}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag}
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
                onTagNotFound={handleDeveloperNotFound}

            />
            {/* Render tags */}
            {/* {tags.map((tag) => (
                <span key={tag.id}>{tag.name}</span>
            ))} */}
        </div>
    );
});

export default Comp_ProjectDeveloper;
